module.exports = __webpack_public_path__ + "images/Peloton_Interactive-fc1b8a.png";